import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, useTheme } from '@mui/material';
import { UploadFile } from '@mui/icons-material';
export const InputWithDrop = memo(function InputWithDrop(props) {
    const { onFileSelect, multiple, accept, check_files_text, ...rest } = props;
    const onDrop = useCallback((accepted_files) => {
        if (accepted_files == null) {
            return;
        }
        onFileSelect(accepted_files);
    }, [onFileSelect]);
    const input_ref = useRef(null);
    const onClick = useCallback(() => {
        if (input_ref.current != null) {
            input_ref.current.click();
        }
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    const { ref, ...rootProps } = getRootProps();
    const theme = useTheme();
    return (_jsxs(Box, { display: "flex", sx: {
            backgroundImage: isDragActive
                ? `repeating-linear-gradient(-45deg, ${theme.palette.background.paper}, ${theme.palette.background.paper} 25px, ${theme.palette.divider} 25px, ${theme.palette.divider} 50px)`
                : '',
            backgroundSize: isDragActive ? '150% 100%' : '',
            border: isDragActive ? 'solid' : 'dashed',
            borderColor: isDragActive
                ? theme.palette.primary.light
                : theme.palette.divider,
            position: 'relative',
            width: '100%',
            minHeight: '50px',
            borderRadius: 'shape.borderRadius',
            boxSizing: 'border-box',
            cursor: 'pointer',
            overflow: 'hidden',
        }, ...rootProps, ...rest, onClick: onClick, children: [_jsx("input", { ...getInputProps(), accept: accept, multiple: !!multiple, ref: input_ref }), _jsx(Typography, { variant: "subtitle1", color: "textSecondary", flexGrow: 1, sx: { m: 2 }, children: isDragActive
                    ? 'Опустите сюда файлы'
                    : check_files_text ?? 'Выберите файлы' }), _jsx(UploadFile, { color: "disabled", sx: { m: 2 } })] }));
});
